// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 检查服务状态 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /promotion-service/check */
export async function promotionServiceCheckUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.promotionServiceCheckUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/promotion-service/check', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 检查用户营销服务有效状态 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /promotion-service/check-list */
export async function promotionServiceCheckListUsingPOST(
  body: API.PromotionServiceReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListPromotionServiceResp>('/promotion-service/check-list', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 检查链接是否有效并返回链接信息 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /promotion-service/invite-link/info */
export async function promotionServiceInviteLinkInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.promotionServiceInviteLinkInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultPromotionServiceInviteLinkInfo>(
    '/promotion-service/invite-link/info',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 检查链接是否有效并返回链接信息 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /promotion-service/invite/info */
export async function promotionServiceInviteInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.promotionServiceInviteInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultPromotionServiceInviteInfoResp>('/promotion-service/invite/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 检查链接是否有效并返回链接信息 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /promotion-service/invite/subscribe */
export async function promotionServiceInviteSubscribeUsingPOST(
  body: API.PromotionServiceInviteSubscribeReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultPromotionServiceInviteSubscribeResp>(
    '/promotion-service/invite/subscribe',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 营销产品领取页预览 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /promotion-service/page/preview */
export async function promotionServicePagePreviewUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.promotionServicePagePreviewUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultPromotionServicePageConfigInfoPreviewResp>(
    '/promotion-service/page/preview',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 服务订阅 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /promotion-service/subscribe */
export async function promotionServiceSubscribeUsingPOST(
  body: API.PromotionServiceSubscribeReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/promotion-service/subscribe', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
